export default __webpack_public_path__ + "static/media/universe4.fae1e759.png";